import { EDGE_HIGHLIGHT_COLOR } from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getNodeHighlightedEdges } from './helpers/getNodeHighlightedEdges';
import { highlightEdges } from './highlightEdges';

export const showHighlightedEdges: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const { pathlookup } = cmdContext.getState();
    const { activeNodeSn, highlightedEdges } = pathlookup.pathInspector;
    const nodeHighlightedEdges = getNodeHighlightedEdges(
      activeNodeSn,
      highlightedEdges,
    );
    if (nodeHighlightedEdges !== undefined) {
      dispatch(highlightEdges, {
        color: EDGE_HIGHLIGHT_COLOR,
        edges: [
          ...nodeHighlightedEdges.incomingEdges,
          ...nodeHighlightedEdges.outgoingEdges,
        ],
      });
    }
  };
